<template>
    <div>
        <filters
            :clearingInstituteOptions="clearingInstitutes"
            :search="search"
            @search="searchTransactions($event)"
        ></filters>
        <tree
            :dialog="dialog1"
            @close="dialog1 = $event"
            @selectMerchant="selectMerchant($event)"
            @resetTree="resetTree($event)"
        ></tree>

        <v-row>
            <v-col class="py-0">
                <v-btn
                    small
                    :outlined="!merchantsFilterBtn"
                    dark
                    color="primary"
                    class="mb-3"
                    @click="dialog1 = true"
                    ><v-icon>mdi-format-list-bulleted</v-icon>
                </v-btn>
            </v-col>

            <v-col align="end" class="py-0">
                <v-btn
                    small
                    dark
                    color="primary"
                    class="mb-3 mr-2"
                    @click="refresh"
                    ><v-icon>mdi-refresh</v-icon>
                </v-btn>
                <v-btn
                    small
                    dark
                    color="primary"
                    class="mb-3"
                    @click="download"
                    ><v-icon>mdi-arrow-down-bold</v-icon>
                </v-btn>
            </v-col>
        </v-row>

        <!-- Stats -->
        <v-row>
            <v-col md="6" class="pt-0 caption stats">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn x-small color="primary" tile class="elevation-0" v-on="on">
                            <v-icon class="px-1" small color="white">mdi-sigma</v-icon>{{ new Intl.NumberFormat('en-US').format(stats.total) }}
                        </v-btn>
                    </template>
                    Total Transactions
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn x-small color="success" tile class="elevation-0" v-on="on">
                            <v-icon class="px-1" small color="white">mdi-check-circle</v-icon> {{ new Intl.NumberFormat('en-US').format(stats.successful) }}
                        </v-btn>
                    </template>
                    Successful Transactions
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn x-small color="error" tile class="elevation-0" v-on="on">
                            <v-icon class="px-1" small color="white">mdi-close-circle</v-icon> {{ new Intl.NumberFormat('en-US').format(stats.failed) }}
                        </v-btn>
                    </template>
                    Failed Transactions
                </v-tooltip>
            </v-col>

            <v-col md="6" class="pt-0 caption stats justify-end">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn x-small color="success" tile class="elevation-0" v-on="on">
                            <v-icon class="px-1" small color="white">mdi-check-circle</v-icon>
                            {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP' }).format(stats.debitAmount) }} /
                            {{ new Intl.NumberFormat('en-US').format(stats.debitVol) }}
                        </v-btn>
                    </template>
                    Successful Debit
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn x-small color="error" tile class="elevation-0" v-on="on">
                            <v-icon class="px-1" small color="white">mdi-sync-circle</v-icon>
                            {{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP' }).format(stats.creditAmount) }} /
                            {{ new Intl.NumberFormat('en-US').format(stats.creditVol) }}
                        </v-btn>
                    </template>
                    Successful Credit/Refunds
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn x-small color="primary" dark tile class="elevation-0" v-on="on">
                            <v-icon class="px-1" small color="white">mdi-scale-balance</v-icon>{{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'GBP' }).format(stats.balance) }}
                        </v-btn>
                    </template>
                    Overall Balance
                </v-tooltip>
            </v-col>
        </v-row>
        
        <!-- Transactions Table -->
        <v-data-table
            :headers="tableHeaders"
            :items="tableData"
            :items-per-page="10"
            :loading="loading"
            class="elevation-1"
        >
        <template v-slot:item.processingTime="{ item }">
            {{ bst(item.processingTime) }}
        </template>
        <template v-slot:item.status="{ item }">
            <v-icon v-if="item.status == 1" color="green" size="14">
                mdi-check-circle
            </v-icon>
            <v-icon v-if="item.status == 0" color="red" size="14">
                mdi-close-circle
            </v-icon>
            <v-icon v-if="item.status == 2" color="primary" size="14">
                mdi-progress-clock
            </v-icon>
        </template>
        ><template v-slot:item.info="{ item }">
            <v-btn @click="information(item)" text icon color="grey">
                <v-icon color="grey" size="22">
                    mdi-information
                </v-icon>
            </v-btn>
        </template>
        </v-data-table>

        <!-- More Information -->
        <information
            :visible="dialog2"
            :info="info !== null ? JSON.parse(info.json).payload : null"
            :binData="info !== null && 'binData' in info ? JSON.parse(info.binData) : null"
            :scheduleDates="scheduleDates"
            :state="$store.state.sysState"
            @close="dialog2 = $event"
            @getTransactions="getTransactions()"
        ></information>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import Filters from '@/components/transactions/Filters.vue';
import Tree from '@/components/transactions/Tree.vue';
import Information from '@/components/transactions/Information.vue';

export default {
    components: {
        'filters': Filters,
        'tree': Tree,
        'information': Information
    },
    data() {
        return {
            uri: this.$store.state.sysState ? 'live' : 'test',
            tableHeaders: [{ text: 'Status', value: 'status', sortable: false, align: 'center' },
                           { text: 'Date', value: 'processingTime', sortable: false },
                           { text: 'Merchant', value:'merchantName', sortable: false },
                           { text: 'Channel', value:'channelName', sortable: false },
                           { text: 'Card Holder', value: 'holder', sortable: false },
                           { text: 'Payment Type', value: 'paymentType', sortable: false, align: 'center' },
                           { text: 'Merchant Transaction ID', value: 'merchantTransactionId', sortable: false },
                           { text: 'Payment Brand', value: 'paymentBrand', sortable: false, align: 'center' },
                           { text: 'Amount', value: 'amount', sortable: false, align: 'center' },
                           { text: 'Currency', value: 'currency', sortable: false, align: 'center' },
                           { text: 'Information', value: 'info', sortable: false, align: 'center' }],
            tableData: [],
            clearingInstitutes: null,
            dialog1: false,
            dialog2: false,
            search: { transactionId: null,
                      status: null,
                      holder: null,
                      bin: null,
                      last4Digits: null,
                      email: null,
                      ip: null,
                      paymentType: [],
                      merchantTransactionId: null,
                      threeDSecure: null,
                      paymentBrand: null,
                      amount: null,
                      recurringType: null,
                      clearingInstitute: null,
                      resultCode: null,
                      uuid: { channel: null, merchant: null, division: null },
                      fromDate: new Date().toISOString().substr(0, 10),
                      toDate: new Date().toISOString().substr(0, 10)
            },
            loading: false,
            info: null,
            scheduleDates: null,
            merchantsFilterBtn: false,
            stats: { total: 0,
                     successful: 0,
                     failed: 0,
                     debitAmount: 0.00,
                     debitVol: 0,
                     creditAmount: 0.00,
                     creditVol: 0 }
        }
    },
    beforeMount() {
        this.getTransactions();
        this.getClearingInstitutes();
    },
    computed: {
        
    },
    methods: {
        getTransactions() {
            if(this.$store.state.user.user_role.id <= 3) {
                this.master();
                this.masterStats();
                this.loading = true;
            }
            else {
                this.client();
                this.clientStats();
                this.loading = true;
            }
        },
        master() {
            axios({
            method: 'post',
            url: 'get-transactions-live',
            data: { search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.tableData = response.data;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        masterStats() {
            axios({
            method: 'post',
            url: 'get-stats-live',
            data: { search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                console.log(response.data);
                this.stats = { total: 0,
                               successful: 0,
                               failed: 0,
                               debitAmount: 0.00,
                               debitVol: 0,
                               creditAmount: 0.00,
                               creditVol: 0,
                               balance: 0.00 }

                response.data.filter(e => {
                    this.stats.total += e.vol;

                    if(e.status == 1) {
                        this.stats.successful += e.vol;
                    }

                    if(e.status == 0) {
                        this.stats.failed += e.vol;
                    }

                    if(e.status == 1 && (e.paymentType == 'DB' || e.paymentType == 'CP' || e.paymentType == 'RB')) {
                        this.stats.debitAmount += parseFloat(e.amountGBP);
                        this.stats.debitVol += e.vol;
                    }

                    if(e.status == 1 && (e.paymentType == 'RF' || e.paymentType == 'RV')) {
                        this.stats.creditAmount += parseFloat(e.amountGBP);
                        this.stats.creditVol += e.vol;
                    }
                });
                this.stats.balance = this.stats.debitAmount - this.stats.creditAmount;
                console.log(this.stats);
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        client() {
            axios({
            method: 'post',
            url: 'get-transactions-live-client',
            data: { userId: this.$store.state.user.id, search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.tableData = response.data;
                this.loading = false;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        clientStats() {
            axios({
            method: 'post',
            url: 'get-stats-live-client',
            data: { userId: this.$store.state.user.id, search: this.search },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                console.log(response.data);
                this.stats = { total: 0,
                               successful: 0,
                               failed: 0,
                               debitAmount: 0.00,
                               debitVol: 0,
                               creditAmount: 0.00,
                               creditVol: 0,
                               balance: 0.00 }

                response.data.filter(e => {
                    this.stats.total += e.vol;

                    if(e.status == 1) {
                        this.stats.successful += e.vol;
                    }

                    if(e.status == 0) {
                        this.stats.failed += e.vol;
                    }

                    if(e.status == 1 && (e.paymentType == 'DB' || e.paymentType == 'CP' || e.paymentType == 'RB')) {
                        this.stats.debitAmount += parseFloat(e.amountGBP);
                        this.stats.debitVol += e.vol;
                    }

                    if(e.status == 1 && (e.paymentType == 'RF' || e.paymentType == 'RV')) {
                        this.stats.creditAmount += parseFloat(e.amountGBP);
                        this.stats.creditVol += e.vol;
                    }
                });
                this.stats.balance = this.stats.debitAmount - this.stats.creditAmount;
                console.log(this.stats);
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        getClearingInstitutes() {
            axios({
            method: 'get',
            url: 'get-clearing-institutes-live',
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.clearingInstitutes = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        information(item) {
            this.dialog2 = true;
            this.info = item;

            console.log(item);
            
            if(JSON.parse(item.json).payload.paymentType == 'SD') {
                axios({
                method: 'post',
                url: 'get-references-live',
                data: { referenceId: this.info.referencedId },
                config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                })
                .then(response => {
                    let reference = response.data;
                
                    axios({
                        method: 'post',
                        url: 'cron-to-dates',
                        data: { cron: JSON.parse(item.json).payload.job.execution.expression, startDate: JSON.parse(item.json).payload.job.startDate, reference: reference },
                        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                        })
                        .then(response => {
                            this.scheduleDates = response.data;
                        })
                        .catch(e => {
                            this.errors.push(e)
                    })
                })
                .catch(e => {
                    this.errors.push(e)
                })
            }
        },
        selectMerchant(e) {
            if(typeof e !== "undefined" && 'id' in e) {
                if('children' in e) {
                    this.search.uuid = { 'merchant': e.id };
                    if('children' in e.children[0]) {
                        this.search.uuid = { 'division': e.id };
                    }
                }
                else {
                    this.search.uuid = { 'channel': e.id };
                }
                this.getTransactions();

                this.merchantsFilterBtn = true;
            }
            else {
                this.merchantsFilterBtn = false;
            }
        },
        resetTree(e) {
            this.search.uuid = null;
            this.dialog = e;
            this.getTransactions();
        },
        searchTransactions(e) {
            this.search = e;
            this.getTransactions();
        },
        download() {
            if(this.$store.state.user.user_role.id <= 3) {
                axios({
                    method: 'post',
                    url: 'download-transactions-report',  
                    data: { search: this.search },              
                    responseType: 'blob',
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'transactions-report.csv');
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            }
            else {
                axios({
                    method: 'post',
                    url: 'download-transactions-report-client',  
                    data: { userId: this.$store.state.user.id, search: this.search },              
                    responseType: 'blob',
                    config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
                    })
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'transactions-report.csv');
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(e => {
                        this.errors.push(e)
                })
            }
        },
        bst(time) {
            if(moment(time).isDST()) {
                return moment(time).add(1, 'hour').format('YYYY-MM-DD HH:mm:ss');
            }
            else {
                 return time;
            }
        },
        refresh() {
            this.getTransactions();
        }
    }
}
</script>

<style>
    .v-data-table td {
        font-size: 0.6rem !important;
    }

    .stats {
        display: inline-flex;
        vertical-align: middle;
        align-items: center;
    }
</style>